import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { AppIcon } from '../app-icon/app-icon';

type NativeButtonType = 'button' | 'submit' | 'reset';
type ButtonSmallType = 'badge' | 'border' | 'normal';

@Component({
  selector: 'app-button-small',
  imports: [AppIcon],
  templateUrl: './app-button-small.html',
  styleUrl: './app-button-small.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ButtonSmallComponent {
  readonly nativeType = input<NativeButtonType>('button');
  readonly buttonType = input<ButtonSmallType>('badge');
  readonly disabled = input(false);
  readonly ariaLabel = input<string | null>(null);
  readonly preIcon = input<string | null>(null);
  readonly postIcon = input<string | null>(null);
  readonly iconColor = input<string | null>(null);
  readonly iconWidth = input(14);
  readonly iconHeight = input(14);

  readonly pressed = output<void>();

  protected emitPressed(): void {
    this.pressed.emit();
  }
}
